<template>
  <div class="header">
    <header>
      <img
        :src="system.logo"
        alt=""
        @click="getCate({ parent: meanTree._child[0] })"
      />
      <span
        href=""
        v-for="item in meanTree._child"
        :key="item.id"
        @click="getCate({ parent: item })"
        :style="meanCenterObj.name == item.name ? line : ''"
        >{{ item.title }}
      </span>
      <!-- <div @keyup.enter="search(keywords)">
        <input type="text" placeholder="产品名称" v-model="keywords" />
        <span class="iconfont icon-sousuo" @click="search(keywords)"></span>
      </div> -->
    </header>
    <div v-if="meanCenterObj.name !== 'Index' && hrefName !== 'articelG'">
      <div>
        <el-carousel
          :interval="5000"
          height="42.7vw"
          v-if="meanCenterObj.name == 'Go'"
        >
          <el-carousel-item v-for="item in carousel" :key="item.id">
            <div class="inside">
              <el-image :src="item.image" alt="" />
              <p>{{ item.name }}</p>
              <p>{{ item.description }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <img :src="meanCenterObj.image" class="bgimg" alt="" v-else />
      </div>
      <div
        class="tabsCenter"
        v-if="
          ['Index', 'Scientific', 'Personnel'].indexOf(meanCenterObj.name) < 0
        "
      >
        <div>
          <ul class="ul_bar">
            <li
              v-for="item in meanCenterObj._child"
              :key="item.id"
              :style="meanCenterObj.tabName == item.name ? ul_select : ''"
              @click="
                gogetCate({
                  parent: meanCenterObj,
                  _child: item,
                })
              "
            >
              {{ item.title }}
              <transition name="el-zoom-in-top">
                <div
                  :style="{
                    'width':
                      15.8 * (meanCenterObj.tabName == 'cancerP' ? 2 : 5) +
                      'vw',
                    left:
                      meanCenterObj.tabName == 'cancerP'
                        ? 11.15 + 8.3 + 'vw'
                        :(100- 15.8 * (meanCenterObj.tabName == 'cancerP' ? 2 : 5))/2+'vw',
                  }"
                  class="select"
                  v-if="
                    childUl &&
                    item._child &&
                    meanCenterObj.name == 'Product' &&
                    meanCenterObj.tabTitle == item.title
                  "
                >
                  <!-- left:meanCenterObj.tabName == 'cancerP' ?(100- 15.8 * (meanCenterObj.tabName == 'cancerP' ? 2 : 5))/2+'vw' -->

                  <span
                    :style="{
                      flex:
                        meanCenterObj.tabName == 'cancerP'
                          ? '0 0 50%'
                          : '0 0 20%',
                      margin:
                        meanCenterObj.tabName == 'cancerP' ? '0 auto' : null,
                    }"
                    v-for="sitem in item._child"
                    :key="sitem.id"
                    @click.stop="gotoArticel({ cate: sitem })"
                  >
                    {{ sitem.title }}</span
                  >
                </div>
              </transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "meHeader",
  data() {
    return {
      cancerP: {
        flex: "0 0 50%",
        // width:'16.66vw'
      },
      cancerDetectionP: {
        flex: "0 0 20%",
        width: "31.25vw",
      },
      keywords: "",
      childUl: true,
      carousel: [],
      ul_select: { color: "#fff", background: "#1680d9" },
      line: { "border-bottom": "0.2083vw solid #1680d9" },
    };
  },
  computed: {
    ...mapGetters(["meanTree", "meanCenterObj", "system", "isArticel"]),
    ...mapState(["hrefName", "loadOver"]),
  },
  created() {
    this.getCarousel();
    this.getCommon().then((common) => {
      if (!localStorage.getItem("pageCate")) {
        // if (!this.pageCate) {
        window.localStorage.clear();
        this.$router.push({ name: "Index" });
      }
    });
  },
  methods: {
    ...mapActions(["getCate", "toArticel", "getCommon"]),
    ...mapMutations(["setMenu", "setState"]),
    search(e) {
      new Promise((resolve, reject) => {
        this.meanTree._child.map((p) => {
          if (p.name == "Product") {
            resolve(p);
          }
        });
      }).then((p) => {
        this.toArticel({ cate: p.id, id: e }).then((info) => {
          if (info.length == 0) {
            this.$message({
              type: "warning",
              message: "没有您想找的产品",
            });
          } else {
            this.setMenu({ parent: p });
            // 先跳到产品中心
            if (this.hrefName == "") {
              this.setState({
                prop: "hrefName",
                value: "articelG",
              });
              this.$router.push({ name: "articelG" });
            }
          }
        });
      });
    },
    gotoArticel(e) {
      this.toArticel(e).then((res) => {
        this.childUl = false;
      });
    },
    gogetCate(e) {
      if (["cancerP", "cancerDetectionP"].indexOf(e._child.name) > -1) {
        this.$api.CATE(e._child.id).then((cate) => {
          Object.assign(e.parent, {
            // image: this.$public_data.baseURL + cate.cate.image,
            image: cate.cate.image,
          });
          this.$store.commit("setMenu", e);
          // console.log(this.$store.state.meanCenterObj, "tabcenter");
          this.childUl = true;
        });
      } else {
        this.getCate(e).then(() => {
          this.childUl = true;
        });
      }
    },
    getCarousel() {
      this.$api.AD(3).then((res) => {
        // this.$public_data.imageURL(res).then((res) => {
        this.carousel.push(...res);
        // });
      });
    },
  },
};
</script>

<style scoped lang='less'>
.header {
  header {
    height: 5.5vw;
    padding: 0 14vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > img {
      width: 9.6vw;
      height: 1.875vw;
    }
    > span {
      height: 2.08vw;
      cursor: pointer;
      text-align: center;
      min-width: 8.3vw;
      font-size: 1.25vw;
      font-weight: bold;
      margin: 0.52vw;
      padding-bottom: 2.5vw;
      // border-bottom: 0.2083vw solid #1680d9;
      > div {
        width: 80%;
        height: 0.2083vw;
        background: #1680d9;
      }
    }
    > div {
      position: relative;
      font-size: 0.83vw;
      color: #1680d9;

      > input {
        width: 17.7vw;
        height: 2.08vw;
        padding-left: 3.1vw;
        border: 1px solid #1680d9;
        border-radius: 1vw;
        font-size: 0.9vw;
      }
      > span {
        cursor: pointer;
      }
      > span {
        font-size: 1vw;
        position: absolute;
        font-weight: bold;
        left: 1vw;
        top: 0.52vw;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #1680d9;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #1680d9;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #1680d9;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #1680d9;
      }
    }
  }
  .bgimg {
    width: 100%;
    height: 29.84vw;
  }
  .select {
    background-image: url("../../assets/image/cannerbg.png");
    background-size: 100%;
    box-shadow: 0.26vw 0.26vw 1vw 0 #eee;
    position: absolute;
    // left: 11.15vw;
    left: 0;
    // top: 3.645vw;
    top: 39vw;
    color: #333;
    font-weight: 600;
    // background: #fff;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    span:hover {
      color: #1680d9;
    }
    > span {
      text-align: center;
    }
    > li {
      cursor: pointer;
      height: 3.645vw;
      line-height: 3.645vw;
    }
    > li:hover {
      color: #1680d9;
    }
  }
  .tabsCenter {
    width: 100vw;
    background: #eaf7ff;
    margin-top: -3px;
    > div {
      // position: relative;
      width: 77.7vw;
      margin: 0 auto;
      .ul_bar {
        height: 3.645vw;
        display: flex;
        align-items: center;
        > li {
          font-size: 1vw;
          text-align: center;
          min-width: 8.3vw;
          padding: 0 1vw;
          height: 100%;
          line-height: 3.645vw;
        }
        li:hover {
          cursor: pointer;
          color: "#fff";
          background: "#1680d9";
        }
      }
    }
  }
  .inside {
    width: 100vw;
    height: 42.7vw;
    font-size: 2.4vw;
    font-weight: bold;
    color: #fff;
    .el-image {
      height: 42.7vw;
      width: 100vw;
    }

    p {
      position: absolute;
      top: 21.67vw;
      left: 56vw;
    }
    > p:last-child {
      top: 26.04vw;
      left: 60vw;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/meHeader.vue